export enum ChatConversationType {
    Dm = 'dm',
    PrivateGroup = 'private_group',
    ModuleGroup = 'module_group',
    GeneralModuleGroup = 'general_module_group',
}
